module.exports = __webpack_public_path__ + "static/media/infoJumbo3.07ff8637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/carif/images/infoJumbo3.jpg
// module id = 556
// module chunks = 0